import {AppInsights} from "applicationinsights-js";

export const addTelemetryInitializer = (telemetryInitializer) => {
    AppInsights.queue.push(() => AppInsights.context.addTelemetryInitializer(telemetryInitializer));
};
